module.exports = __webpack_public_path__ + "static/media/night5.3617b84d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/night5.jpeg
// module id = 28
// module chunks = 0